// What the admin shows before its screens can (SPEC-33): the wait, drawn as
// the page's skeleton since SPEC-43, and a failure with its retry. App.tsx
// loads this file at startup, so the admin's own chunk has something to
// show while it arrives, or when it cannot. It sits inside the language's
// provider, so it speaks the admin's language from the first frame
// (SPEC-38).

import { useCopy } from "../i18n/LanguageProvider";
import { AdminPageSkeleton } from "./Skeleton";
import { primaryButton } from "./styles";

const page = "flex min-h-dvh flex-col items-center justify-center gap-4 bg-cream px-5 text-center";

/** The base's failure, or the one a screen names, and the retry. */
export function Failed({ message, onRetry }: { message?: string; onRetry: () => void }) {
  const text = useCopy().admin;
  return (
    <div className="flex flex-col items-center gap-4 text-center">
      <p role="alert" className="text-body text-muted">
        {message ?? text.failed}
      </p>
      <button type="button" onClick={onRetry} className={primaryButton}>
        {text.retry}
      </button>
    </div>
  );
}

/** SPEC-43: the page's shape while the admin's chunk, its session and its gate arrive. */
export function AdminLoading() {
  return <AdminPageSkeleton />;
}

export function AdminFailed({ onRetry }: { onRetry: () => void }) {
  return (
    <main className={page}>
      <Failed onRetry={onRetry} />
    </main>
  );
}

/**
 * In place of the admin when its chunk could not be fetched. A browser keeps
 * a failed dynamic import until the page reloads (src/lib/firebaseModules.ts),
 * so the retry reloads.
 */
export function AdminUnavailable() {
  return <AdminFailed onRetry={() => window.location.reload()} />;
}
